import { IOptionType } from '@zz2/zz2-ui';
import { RightGrantsEnum } from './@types/enum/rightGrantsEnum';
import { RightTypeEnum } from './@types/enum/rightTypeEnum';

export const MAP_CENTER_POSITION : { lat : number; long : number } = {
    lat: -23.5792,
    long: 30.1424,
};

export const IMPORTED_TYPE_INPUT_FIELD = 'Cannot change this input field if this entry is imported.';

export const QUERY_DATA_STALE_TIME = 30 * 60 * 1000;

export const SNACKBAR_WIDTH = 400;

export const RIGHT_GRANT_LEVELS : Record<string, number> = {
    'View': RightGrantsEnum.View,
    'Add': RightGrantsEnum.Add,
    'Edit': RightGrantsEnum.Edit,
    'Delete': RightGrantsEnum.Delete,
    'Admin': RightGrantsEnum.Admin,
};

export const RIGHT_GRANT_LEVEL_OPTIONS : Array<{ label : string; value : number }> = [
    { label: 'View', value: RightGrantsEnum.View },
    { label: 'Add', value: RightGrantsEnum.Add },
    { label: 'Edit', value: RightGrantsEnum.Edit },
    { label: 'Delete', value: RightGrantsEnum.Delete },
    { label: 'Admin', value: RightGrantsEnum.Admin },
];

export const RIGHT_TYPE_OPTIONS : Array<{ label : string; value : number }> = [
    { label: 'Incident', value: RightTypeEnum.Incident },
    { label: 'Observation', value: RightTypeEnum.Observation },
    { label: 'Right', value: RightTypeEnum.Right },
    { label: 'Access Point Event', value: RightTypeEnum.AccessPointEvent },
    { label: 'Master Data', value: RightTypeEnum.Master },
    { label: 'Mobile', value: RightTypeEnum.Mobile },
    { label: 'Grave Sites', value: RightTypeEnum.GraveSites },
    { label: 'Occurrence', value: RightTypeEnum.Occurrence },
];

/* Default rights (Pages accessible to all users) */
export const DEFAULT_RIGHTS = ['/faq'];

export const LANGUAGES = [
    'Afrikaans',
    'Chewa',
    'English',
    'isiNdinbele',
    'isiZulu',
    'Sepedi',
    'Sesotho',
    'Setswana',
    'Shona',
    'siSwati',
    'Tshivenda',
    'Tsonga',
    'Venda',
    'Xhosa',
    'Xitsonga',
];

export const PROVINCES = [
    'Eastern Cape',
    'Free State',
    'Gauteng',
    'KwaZulu-Natal',
    'Limpopo',
    'Mpumalanga',
    'North West',
    'Northern Cape',
    'Western Cape',
];

// available default home screens
export const AVAILABLE_DEFAULT_HOME_SCREENS : Array<IOptionType> = [
    { label: 'Home', value: '/home' },
    { label: 'Notification Map', value: '/map' },
];

// TODO: Make these 3 lists into master data
export const POACHING_METHOD_OPTIONS : Array<IOptionType> = [
    { label: 'Firearms', value: 0 },
    { label: 'Fishing Nets', value: 1 },
    { label: 'Fishing Rods', value: 2 },
    { label: 'Poison', value: 3 },
    { label: 'Snare Wires', value: 4 },
    { label: 'Spears/Dogs', value: 5 },
    { label: 'Traps', value: 6 },
];

export const HOUSEBREAKING_ENTRY_POINT_OPTIONS = [
    { label: 'Window(s)', value: 0 },
    { label: 'Back Door', value: 1 },
    { label: 'Front Door', value: 2 },
    { label: 'Garage Doo', value: 3 },
];

export const WEATHER_CONDITION_OPTIONS = [
    { label: 'Clear', value: 0 },
    { label: 'Cloudy', value: 1 },
    { label: 'Rain', value: 2 },
    { label: 'Thunderstorm', value: 3 },
    { label: 'Hail', value: 4 },
];

export const INCIDENT_TYPE_TO_TEXT : {[key : number] : string} = {
    1: 'Evidence',
    2: 'Incident',
    3: 'Suspect',
};

export const DATE_FORMAT_SUMMARY = 'DD/MM/YYYY HH:mm';

// export const OBSERVATION_NOTIFICATION = 1;
// export const INCIDENT_NOTIFICATION = 2;
// export const OCCURENCE_NOTIFICATION = 3;

// export const RIGHT_TO_ICON : {[key : string] : string} = {
//     USER : `${ASSET_BASE}/assets/images/icons/users.svg`,
//     ROLE : `${ASSET_BASE}/assets/images/icons/roles.svg`,
//     ACCESSEV : `${ASSET_BASE}/assets/images/icons/access_event_vehicle.svg`,
//     ACCESSEP : `${ASSET_BASE}/assets/images/icons/users.svg`,
//     ACCESSP : `${ASSET_BASE}/assets/images/icons/gate_remote_controlled.svg`,
//     INS_CAT : `${ASSET_BASE}/assets/images/icons/incidentCategory.svg`,
//     DIV_EDIT : `${ASSET_BASE}/assets/images/icons/division.svg`,
//     REG_EDIT : `${ASSET_BASE}/assets/images/icons/region.svg`,
//     INS_GROUP : `${ASSET_BASE}/assets/images/icons/incidentCategory.svg`,
//     ACCESS_POINT_CAT : `${ASSET_BASE}/assets/images/icons/access_point_category.svg`,
//     GRAVE_REASON : `${ASSET_BASE}/assets/images/icons/grave_site_visit_reason.svg`,
// };

// export const ACCESS_POINT_TYPE_STRING : {[key : number] : string} = {
//     0 : 'Unknown',
//     1 : 'Gate',
// };

// export const ACCESS_POINT_TYPE_TO_ICON : {[key : string] : string} = {
//     0 : `${ASSET_BASE}/assets/images/icons/unkown_acp.svg`,
//     1 : `${ASSET_BASE}/assets/images/icons/gate.svg`,
// };

// export const ACCESS_POINT_REASONS : {[key : string] : string} = {
//     WRK : 'Work',
//     MEE : 'Meeting',
//     DEL : 'Delivery',
//     RES : 'Resident',
//     VIS : 'Visit',
//     MAR : 'Market',
//     COL : 'Collection',
// };

// export enum RIGHTS {
//     RIGHTS = 1,
//     USER = 2,
//     INS = 3,
//     OBS = 4,
//     ROLE = 5,
//     ACCESSE = 6,
//     MASTER = 7,
//     ACCESSP = 8,
//     ACCESSEV = 9,
//     INS_EDIT = 10,
//     INS_CAT = 11,
//     DIV_EDIT = 12,
//     REG_EDIT = 13,
//     ACCESSEP = 14,
//     INS_VIRUS_COVID19 = 15,
//     ACCESSEV_VIEW = 16,
//     ACCESSEP_VIEW = 17,
//     INS_DEL = 18,
//     OBS_DEL = 19,
//     OBS_EDIT = 20,
//     MOBILE = 21,
//     MACCESSP = 22,
//     GRAVESITE = 23,
//     INS_APPROVE = 24,
//     INS_GROUP = 25,
//     GRAVE_REASON = 26,
//     ACCESS_POINT_CAT = 27,
//     DIVISION_TYPE = 28,
//     USER_DETAILS = 29,
//     USER_DIVISIONS = 30,
//     USER_ACCESS_POINT = 31,
//     USER_RIGHTS = 32,
//     OCC = 35,
//     OCC_DEL = 36,
//     OCC_EDIT = 37,
// }

// export enum ROLES {
//     SCHEDULER = 999,
//     MANAGER = 1000,
//     GUARD = 1001,
// }

// export const SYMPTOM_TYPE : {[key : number] : string} = {
//     0 : 'Covid-19',
// };
